import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMovements } from "../api";
import { scrollToTop, tokenSolver, getImg, MovementTag } from "../utils";
import {
  CoalitionSpinner,
  EmptyBlock,
  CoalitionButton,
  isTokenValid,
} from "../components";
import { SingleProductImg } from "../components/CoalitionComplements";
import { empty_movements, chevron_left, not_img, mov_icon } from "../pngs";
import "./WildCardPage.scss";
import "./Pages.scss";

export const MovementsPage = () => {
  const [loading, setLoading] = useState(false);
  const [movs, setMovs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const fetchData = async () => {
      setLoading(true);
      const movements = await getMovements();
      setMovs(movements);
      scrollToTop();
      setLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div className="public-page">
      {loading ? (
        <CoalitionSpinner />
      ) : (
        <PagePrebuilt
          movements={movs}
          buttonClicked={() => navigate(`/?${tokenSolver()}`)}
        />
      )}
    </div>
  );
};

const PagePrebuilt = ({ movements = [], buttonClicked }) => {
  const [movs, setMovs] = useState();

  useEffect(() => {
    const buildMovements = () => {
      const movsToDrawFiltered = movements.filter((mov) => mov.data.length > 0);
      if (!movsToDrawFiltered || movsToDrawFiltered.length === 0) return;
      // eslint-disable-next-line array-callback-return
      movsToDrawFiltered.map((block) => {
        block.data.sort(
          (a, b) => new Date(b.transaction_date) - new Date(a.transaction_date)
        );
      });
      const movsAsHtml = movsToDrawFiltered.map((movement, k) => (
        <MovementsCard key={k} {...movement} />
      ));
      setMovs(movsAsHtml);
    };
    buildMovements();
  }, [movements]);

  const title = "Movimientos de tus puntos";
  const emptyDesc = "Comienza a usar tu programa de lealtad para ganar puntos";

  return (
    <>
      <div className="movements-page">
        {!movements || movements.length === 0 ? (
          <div className="no-content">
            <EmptyBlock
              title={title}
              description={emptyDesc}
              emptyState={empty_movements}
            >
              <CoalitionButton
                label="Volver al Inicio"
                klass="coalition-button-go-dashboard"
                onClickEvent={buttonClicked}
              />
            </EmptyBlock>
          </div>
        ) : (
          <div className="page-content">
            <CoalitionButton
              label={title}
              klass="nav-button"
              onClickEvent={buttonClicked}
            >
              {getImg(chevron_left, "back-icon")}
            </CoalitionButton>
            <div className="movements">{movs}</div>
          </div>
        )}
      </div>
    </>
  );
};

const MovementsCard = ({ title, data }) => {
  return (
    <div className="movement-card">
      <div className="date">{Titlelize(title)}</div>
      {data.map((info, i) => (
        <MovementRow key={i} {...info} />
      ))}
    </div>
  );
};

const MovementRow = ({
  sponsor_name,
  brand_image,
  bits,
  is_accrual,
  transaction_date,
}) => {
  const formattedDate = new Date(transaction_date).toLocaleDateString("es-mx", {
    weekday: "long",
    day: "numeric",
  });
  return (
    <>
      <div className="movement-container">
        <div className="container-logo">
          <div className="logo">
            <SingleProductImg load={brand_image} error={not_img} />
          </div>
        </div>
        <div className="container-description">
          <div className="description">
            <div className="title">{sponsor_name}</div>
            <div className="detail">{Titlelize(formattedDate)}</div>
          </div>
        </div>
        <div className="container-ammount">
          <div className="ammount">
            <label>
              {is_accrual ? "+" : "-"}
              {<MovementTag bits={bits} />} {getImg(mov_icon, "mov-icon")}
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

const Titlelize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
